import { alpha } from '@mui/material/styles';

const overrideBackdropStyles = theme => ({
  MuiBackdrop: {
      styleOverrides: {
        root: {
          backgroundColor: alpha(theme.palette.grey[800], 0.8)
        },
        invisible: {
          background: 'transparent'
        }
      }
    }
})

export default overrideBackdropStyles
